var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center h-screen flex items-center justify-center text-2xl"},[_vm._v("Vous êtes perdu :(")])}
var staticRenderFns = []

export { render, staticRenderFns }